<template>
    <ul class="score-indicator">
        <li v-for="index in 5" :key="index" class="score-dot" :class="{'scored' : index  <= score, 'half': index - score === 0.5}">
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid meet" fill='none' viewBox="0 0 640 608" width="640" height="608">
                <path class='star-path' clip-rule="evenodd" fill-rule="evenodd" d="M517.76 608L465.28 383.04L640 231.68L409.92 212.16L320 0L230.08 212.16L0 231.68L174.72 383.04L122.24 608L320 488.64L517.76 608Z" id="csYMEXeF5"></path>
            </svg>

        </li>
    </ul>
</template>

<script>

    export default {
        name: 'Score',

        props: {
            score: {
                type: Number,
                required: true
            }
        }
    }
</script>
